import React, { useEffect } from "react";
import styled from "@emotion/styled";
import ConfettiGenerator from "confetti-js";

const confettiSettings = {
  target: "confetti",
  max: "120",
  size: "1.5",
  animate: true,
  props: ["circle", "square", "triangle", "line"],
  colors: [
    [29, 182, 178], // turquoise
    [247, 58, 84], // scarlet
    [10, 158, 118], // fern
    [248, 183, 58], // yellow
    [185, 166, 223], // lavender
  ],
  clock: "25",
  rotate: false,
  opacity: false,
  width: "1463",
  height: "1308",
  start_from_edge: false,
  respawn: true,
};

const ConfettiCanvas = styled.canvas`
  height: 100vh;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100vw;
`;

type ConfettiProps = {
  isVisible: boolean;
};

export const Confetti = ({ isVisible }: ConfettiProps) => {
  useEffect(() => {
    if (!isVisible) {
      return;
    }

    const confetti = new ConfettiGenerator(confettiSettings);
    confetti.render();

    return () => confetti.clear();
  }, [isVisible]);

  return isVisible ? <ConfettiCanvas id="confetti" /> : null;
};
